<form #formControl="ngForm">
  <mat-dialog-content>
    <mat-form-field color="accent">
      <input readonly matInput #input placeholder="Field" [(ngModel)]="field.name" name="field" />
    </mat-form-field>

    <!-- <mat-form-field color="accent">
      <input matInput #input placeholder="Field Label" [(ngModel)]='fieldLabel' name="fieldLabel">
    </mat-form-field> -->
  </mat-dialog-content>

  <mat-dialog-actions style="display: flex; flex-direction: row-reverse; padding: 10px">
    <button mat-button [disabled]="!formControl.valid" [mat-dialog-close]="1" (click)="confirmAdd()">Save</button>
    <button mat-button (click)="onNoClick()" tabindex="-1">Cancel</button>
  </mat-dialog-actions>
</form>
